/**
 * Type-safe access to Vite environment variables.
 *
 * To add a new variable:
 *   1. Add it to `.env.example` (and your local `.env`) with the `VITE_` prefix.
 *   2. Add it to {@link ImportMetaEnv} below.
 *   3. Reference it via {@link env}.
 */

interface AppEnv {
  apiBaseUrl: string
  mode: 'development' | 'production' | 'test'
}

const rawApiBaseUrl = import.meta.env.VITE_API_BASE_URL ?? ''
const mode = import.meta.env.MODE as AppEnv['mode']

export const env: AppEnv = {
  apiBaseUrl: rawApiBaseUrl.replace(/\/+$/, ''),
  mode,
}

export const isDev = mode === 'development'
export const isProd = mode === 'production'
